/** Rounded metric distances a scale bar may show (m), 1-2-5 per decade. */
const STEPS = [1, 2, 5];

/** Largest round distance (1, 2, 5 x 10^n m) that fits in `maxMeters`. */
export function niceDistance(maxMeters: number): number {
  if (!(maxMeters > 0)) return 0;
  const pow = 10 ** Math.floor(Math.log10(maxMeters));
  let best = pow;
  for (const s of STEPS) if (s * pow <= maxMeters) best = s * pow;
  return best;
}

/** "500 m" / "2 km". */
export function formatDistance(meters: number): string {
  return meters >= 1000 ? `${meters / 1000} km` : `${meters} m`;
}

/** Longest the bar may be, in CSS px. */
export const MAX_PX = 100;

/** Distance from the map's bottom edge to the bar's row (credit row: 8 px inset, about 27 px tall). */
const BAR_ROW_FROM_BOTTOM = 20;

interface ScaleMap {
  getSize(): { y: number };
  containerPointToLatLng(p: [number, number]): { distanceTo(o: unknown): number };
}

/** Metres per CSS pixel at the bar's own row (Web Mercator: it changes with latitude, so not the centre row). */
export function metersPerPixel(map: ScaleMap): number {
  const y = map.getSize().y - BAR_ROW_FROM_BOTTOM;
  const a = map.containerPointToLatLng([0, y]);
  const b = map.containerPointToLatLng([MAX_PX, y]);
  return a.distanceTo(b) / MAX_PX;
}
